import { ReservationForm } from '../elements/ReservationForm';

export const Reservation = () => {
  return <ReservationForm />;
};
